/**
 * @Description:
 * @Author: yanhui.gao
 * @Date: 2019/7/8  10:50
 */

import dbc from '@/api/system/menu';

export default {
  namespaced: true,
  state: {
    haha: 'heihei',
    menu: {},
  },
  actions: {
    /**
     *
     * 系统管理-菜单管理
     */

    /**
     * 菜单管理 获取所有菜单数据，数据不分页
     * @param {*} param0
     * @param {*} param
     */
    getMenuList({ commit }, param) {
      return dbc.getMenuList(param).then((content) => {
        commit('setMenuList', content);
      });
    },
  },
  mutations: {
    // 菜单管理
    setMenuList(state, content) {
      state.menu.list = content.list;
    },
  },
};
